import { render, staticRenderFns } from "./BasicCkeditor.vue?vue&type=template&id=62f8b569&scoped=true&"
import script from "./BasicCkeditor.vue?vue&type=script&lang=js&"
export * from "./BasicCkeditor.vue?vue&type=script&lang=js&"
import style0 from "./BasicCkeditor.vue?vue&type=style&index=0&id=62f8b569&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62f8b569",
  null
  
)

export default component.exports